export interface SurveyPopUpData {
   id: string;
   title: string;
   description: string;
   link: string;
}

export const AnswersData: SurveyPopUpData = {
   id: 'answers',
   title: 'Did you get your Answer?',
   description: 'Answer a few questions to help us improve your experience.',
   link: '/',
};
